import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '@environments/environment';
import { Store } from '@ngxs/store';
import { List } from '@shared/models/interfaces/List.interface';
import { Surveyor } from '@shared/store/surveyors/surveyors.interface';

import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class SurveysSettingsService extends HttpService {
  constructor(httpClient: HttpClient, store: Store) {
    super(environment.endpoints.surveySettings, httpClient, store);
  }

  listSurveyors(token, page, searchName = '', perPage = environment.perPage) {
    const params = new HttpParams()
      .set('perPage', String(perPage))
      .set('page', String(page))
      .set('searchName', String(searchName));
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }),
      params,
    };
    return this.getAsync<List<Surveyor>>(`/surveyors`, httpOptions);
  }
}
